import React from 'react';
import LoadingSpinner from '../components/LoadingSpinner';

const LoadingTest: React.FC = () => {
  return <LoadingSpinner />;
};

export default LoadingTest;
